export const WHOLE_NUMBER_REGEX = /^[0-9]*$/;
export const FILE_NAME_REGEX = /^[a-zA-Z \b]*$/;
export const TEXT_AND_NUMBER_REGEX = /[^0-9a-zA-Z ]/;
